import { IFeatureFlagData } from "../store"

interface IFeatureFlagReturn {
  data: IFeatureFlagData
}

interface IFeatureFlagService {
  get: () => Promise<IFeatureFlagReturn>
}

type TEnvParams = string

const featureFlagService: IFeatureFlagService = {
  get: async () => {
    try {
      const response = await fetch(`cobertura/api/feature-flag`)
      const json = await response.json()
      return {
        data: json
      }
    } catch (error) {
      console.log("Erro ao buscar feature flag: ", error)
    }
  }
}

export default featureFlagService
